import { render, staticRenderFns } from "./FromTo.vue?vue&type=template&id=af7cc61c&scoped=true&lang=pug&"
import script from "./FromTo.vue?vue&type=script&lang=coffee&"
export * from "./FromTo.vue?vue&type=script&lang=coffee&"
import style0 from "./FromTo.vue?vue&type=style&index=0&id=af7cc61c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7cc61c",
  null
  
)

export default component.exports